import React from 'react';
import queryString from 'query-string';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import isEqual from 'lodash/isEqual';
import Browser from '../util/Browser';

class CMP extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      newHtml: false,
      writeScript: null,
      height: window.innerHeight,
    };
  }

  componentDidMount() {
    console.log('>>>>> CMP.componentDidMount()');

    this.applyStyleFixes();
    this.loadScripts();

    // Sent manually when the CMP component loads
    // Not when celtra is rendered
    this.props.didFinishLoad();

    if (get(this.props, 'creative.immediateRender')) {
      this.handleAppOpen();
    } else {
      this.registerForAppOpenEvent();
    }

    if (get(this.props, 'creative.type') === 'html') {
      this.parseScriptsInHtml(get(this.props, 'ad.html', ''));
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (!prevState.imPixelScript && this.state.imPixelScript) {
      console.log('Writing CMP Pixels script tag, as Celtra has shown up!');
      const newS = document.createElement('script');
      newS.type = 'text/javascript';
      newS.setAttribute('m2m', true);
      newS.src = this.state.imPixelScript;
      console.log('CMP.componentDidUpdate() addingtopage - celtra script');
      console.log(newS.src);
      document.body.appendChild(newS);
    }

    if (!prevState.writeScript && this.state.writeScript) {
      this.reDoHeight();
    }

    if (
      prevProps.celtraFixes.e2IframeScale !== this.props.celtraFixes.e2IframeScale ||
      !isEqual(this.props.cardViewState, prevProps.cardViewState)
    ) {
      this.reDoHeight();
    }
    if (!prevProps.openCeltra && this.props.openCeltra) {
      const debug = document.getElementById('moatParamsTextArea');
      if (debug) {
        document.getElementById('moatParamsTextArea').style.background = 'red';
        document.getElementById('moatParamsTextArea').style.color = 'white';
      }
      this.handleAppOpen();
    }

    this.hideCeltraCloseButtons();
  }

  hideCeltraCloseButtons = () => {
    // Function to check if celtra-view exists in iframes and hide celtra-close-button inside it
    const checkIframesAndHideElements = () => {
      const iframes = document.getElementsByTagName("iframe");
      let foundCeltraView = false;

      for (let i = 0; i < iframes.length; i++) {
        try {
          const iframeDoc = iframes[i].contentDocument;
          if (iframeDoc) {
            // Look for celtra-view in iframe
            const celtraViews = iframeDoc.getElementsByClassName('celtra-view');
            if (celtraViews.length > 0) {
              foundCeltraView = true;
              // Hide celtra-close-button inside the celtra-view
              Array.from(celtraViews).forEach(view => {
                const closeButtons = view.getElementsByClassName('celtra-close-button');
                Array.from(closeButtons).forEach(button => {
                  button.style.display = "none";
                });
              });
            }
          }
        } catch (error) {
          console.log(`Could not access iframe due to same-origin policy`);
        }
      }

      // If we found celtra-view in any iframe, hide celtraCloseButtonBackground in main document
      if (foundCeltraView) {
        const allElements = document.getElementsByTagName('div');
        Array.from(allElements).forEach(element => {
          if (element.classList) {
            const hasCeltraClass = Array.from(element.classList).some(className =>
              className.includes('celtraCloseButtonBackground')
            );

            if (hasCeltraClass) {
              element.style.display = "none";
            }
          }
        });
      }
    };

    // Run the main logic
    checkIframesAndHideElements();

    //Set up a MutationObserver to catch any dynamically added elements
    const observer = new MutationObserver(checkIframesAndHideElements);
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  applyStyleFixes = () => {
    const logPrefix = 'DOM Takeover Fixer - ';
    console.log(`${logPrefix}applying styling fixes`);

    const calcTop = Browser.getTopPadding() + Browser.getHeaderHeight();
    const newTop = `${calcTop}px`;

    const noSrcStr = `
      // Preview related
      ${Browser.getParameterValue('preview_in_browser') ? `body { overflow-y: hidden; }` : ``}

      // I'm not sure that these exist any longer,
      // they were originally to prevent Celtra from taking over the header.
      div#eyeDiv iframe:first-of-type {
          height: ${this.state.height - calcTop}px !important;
      }
      div#eyeDiv, div#eyeDiv > div {
          top: ${newTop} !important;
          height: ${this.state.height - calcTop}px !important;
      }

      // no header for Celtra
      #contentNodeCeltra {
        height: 100% !important;
      }
    `;

    const style = document.createElement('style');
    style.id = 'style-fixes';
    style.appendChild(document.createTextNode(noSrcStr));

    // Remove any styles we may have already added
    try {
      const element = window.parent.document.getElementById('style-fixes');
      element.parentNode.removeChild(element);
    } catch (e) {
      // Nothing to worry about, style wasn't added yet
    }

    try {
      window.parent.document.getElementsByTagName('head')[0].appendChild(style);
    } catch (e) {
      document.getElementsByTagName('head')[0].appendChild(style);
    }
  };

  getE2AdHtmlStyle = (html, style) => {
    let newStyles = Object.assign({}, style);
    let e2IframeScale;
    if (e2IframeScale = get(this.props, 'celtraFixes.e2IframeScale')) {
      // alchemer surveys just get a scale of 1
      if (html.indexOf('alchemer') !== -1) {
        e2IframeScale = 'scale(1)';
      }
      newStyles = {
        ...newStyles,
        MozTransform: `${e2IframeScale} translateZ(0) `,
        WebkitTransform: `${e2IframeScale} translateZ(0) `,
        overflow: 'hidden',
      };
      if (html.indexOf('celtra') !== -1) {
        Object.assign(newStyles,{
          MozTransformOrigin: 'center',
          WebkitTransformOrigin: 'center',
          width: '100%',
        });
        newStyles.top = '0px !important';
      } else {
        Object.assign(newStyles, {
          MozTransformOrigin: '0 0',
          WebkitTransformOrigin: '0 0',
          width: 'inherit',
        });
      }
    }
    return newStyles;
  };

  loadScripts = () => {
    console.log('>>>>> CMP.loadScripts()');
    const {
      iframeSrc,
      creative: { type, interstitial_html, noPixel, pixels, immediateRender },
      ad: { impression_id, click_action, click_through_url },
    } = this.props;

    // We don't want to load our pixel scripts if noPixel is true
    if (noPixel) return;

    window.immediateRender = immediateRender;

    const thirdPartyPels = Browser.thirdPartyPels();
    window.imScriptHost = Browser.scriptHost();

    let thirdParams = {};
    if (iframeSrc) {
      const params = queryString.parseUrl(iframeSrc);
      thirdParams = params.query;
    } else {
      // Send all parameters from the ad URL to third par pel via GET arguments
      const params = queryString.parseUrl(get(this.props, 'ad.url', ''));
      thirdParams = params.query;
    }

    if (thirdParams.url) {
      thirdParams = {
        ...thirdParams,
        ...queryString.parseUrl(thirdParams.url).query,
      };
    }

    // An empty line is required for the script to pick it up
    if (!thirdParams.m2m_impr_hash) {
      thirdParams.m2m_impr_hash = '';
    }

    // These should be filled out, but just in case (ie, html type)
    if (!thirdParams.m2m_impr_id) {
      thirdParams.m2m_impr_id = impression_id;
    }
    if (!thirdParams.m2m_ad_is_e2) {
      thirdParams.m2m_ad_is_e2 = 1;
    }
    if (!thirdParams.env) {
      thirdParams.env = Browser.getEnvironment();
    }

    // add params needed for 3pt_pels script to process deeplinks
    thirdParams.click_action = click_action;
    thirdParams.click_through_url = click_through_url;

    thirdParams = queryString.stringify(thirdParams);

    const script = document.createElement('script');
    script.src = `//${thirdPartyPels}&${thirdParams}`;
    script.async = true;
    script.setAttribute('m2m', true);
    window.imPixelScript = script.src;
    this.setState({ imPixelScript: script.src });
    // document.body.appendChild(script);

    // this function does not attempt to base64 decode interstitial_html,
    // the resulting script added to the page will not work if
    // creative.interstitial_html is base64 encoded.
    const htmlScript = document.createElement('script');
    htmlScript.innerHTML = interstitial_html || '';
    htmlScript.id = 'imHtml';
    htmlScript.type = 'text/x-inmarket-html';
    console.log('CMP.loadScripts() addingtopage - script');
    console.log(htmlScript);
    document.body.appendChild(htmlScript);

    // const pelsScript = document.createElement('script');
    // pelsScript.innerHTML = pixels || '';
    // pelsScript.id = '3rdpartyhtml';
    // pelsScript.type = 'text/x-inmarket-3rdparty';
    // document.body.appendChild(pelsScript);
  };

  registerForAppOpenEvent = () => {
    const imprMatch = this.props.ad.impression_id;
    const componentNameMatch = this.props.componentName;
    // let the CardView know we want to know when the app is opened.
    window.top.postMessage(
      JSON.stringify({
        action: 'notify_app_opened',
        m2m_impr_id: imprMatch || null,
        componentName: componentNameMatch || null,
      }),
      '*'
    );
  };

  handleAppOpen = () => {
    console.log('>>>>> CMP.handleAppOpen()', this.props);
    let newHtml = '';
    try {
      newHtml = decodeURIComponent(this.props.creative.interstitial_html);
    } catch (e) {
      newHtml = this.props.creative.interstitial_html;
    }
    console.log('CMP.handleAppOpen - writing newHtml:', newHtml);
    this.parseScriptsInHtml(newHtml);
    this.setState({ newHtml });

    // Sizmek doesn't have a writeScript
    // Custom html type doesn't use writeScript either
    // But we could have custom html type that includes a celtra tag
    if (
      newHtml.indexOf('serving-sys') === -1 &&
      (get(this.props, 'creative.type') !== 'html' || newHtml.indexOf('celtra') !== -1)
    ) {
      // Disable modifying styles
      // Instead, show topbar
      // this.findWriteScript();
    }
  };

  findWriteScript = () => {
    console.log('Finding write script');
    const waitInterval = setInterval(() => {
      let writeScript = false;
      const is = document.getElementsByTagName('iframe');
      for (let i = 0; i < is.length; i++) {
        try {
          if (is[i].contentDocument.querySelector('div#viewport div#celtra-banner') != null) {
            writeScript = is[i];
            this.setState({ writeScript });
            clearInterval(waitInterval);
            console.log('Found writeScript for Celtra');
          }
        } catch (e) {
          console.warn('Unable to select on iframe');
        }
      }
    }, 0); // note: any longer is too long

    // We should stop after 5s
    setTimeout(() => {
      console.log('Did not find writeScript for Celtra, stopping interval to find it');
      clearInterval(waitInterval);
    }, 5000);
  };

  reDoHeight = () => {
    console.log('Redoing height');

    // This is for Celtra only
    if (this.state.writeScript) {
      // Hacky way to add a padding to the top of the Celtra ad so our header isn't hidden
      setInterval(() => {
        if (get(this.state.writeScript, 'parentElement.style.top') === '0px') {
          const calcTop = Browser.getTopPadding() + Browser.getHeaderHeight();
          const newTop = `${calcTop}px`;
          console.log('Setting new topBar on celtra ad', newTop, calcTop);
          const localState = this.state.writeScript;
          localState.parentElement.style.top = newTop;
          localState.parentElement.style.height = `${window.innerHeight - calcTop}px`;
          this.setState({ writeScript: localState });
        }
      }, 50);
    }
  };

  evalScripts = sequence => {
    if (isEmpty(sequence)) return;

    console.log('>>>>> CMP.evalScripts()');
    sequence.forEach(src => {
      if (typeof src === 'string') {
        try {
          console.log('CMP.evalScripts() addingtopage - script string');
          console.log(src);
          eval(src);
        } catch (err) {
          console.warn(`third_party_impr_pels(): exception eval'ing ${src}: `, err);
        }
      } else {
        try {
          console.log('CMP.evalScripts() addingtopage - script');
          console.log(src);
          document.body.insertBefore(src, document.body.lastChild);
        } catch (err) {
          console.warn(`third_party_impr_pels(): exception eval'ing ${src}: `, err);
        }
      }
    });
  };

  parseScriptsInHtml = injectThisHTML5 => {
    console.log('>>>>> CMP.parseScriptsInHtml()');
    console.log(injectThisHTML5);
    // The relative protocol '//m.moat.com/stuff-here' wouldn't work
    // simply setting innerHTML, but the DOMParser handled it just fine.
    const parser = new DOMParser();
    // without wrapping in a div, the parser automatically puts script tags in <head/>
    let d = parser.parseFromString(`<div>${injectThisHTML5}</div>`, 'text/html');
    d = d.body.firstChild;

    const sequence = [];
    let scriptTags;
    const impId = get(this.props, 'ad.impression_id');
    // On this scripts array comes the custom html(celtra) inserted on ventura by marketing to fired third party pixels
    while ((scriptTags = d.getElementsByTagName('script')).length) {
      // script tags handled in executeScriptsSequence, so trim
      const toExecuteS = scriptTags.item(0);
      toExecuteS.parentNode.removeChild(toExecuteS);
      //d.removeChild(toExecuteS);
      console.log(`evaluating tag ${scriptTags.length}`, toExecuteS);

      let newSSrc = toExecuteS.getAttribute('src');
      if (newSSrc) {
        // Append impression id if it doesn't exist
        if (newSSrc.indexOf('third_party_impr_pels.js') !== -1 && newSSrc.indexOf(impId) === -1) {
          newSSrc = `${newSSrc}&m2m_impr_id=${impId}`;
        }

        const newS = document.createElement('script');
        newS.type = toExecuteS.getAttribute('type') || '';
        newS.src = newSSrc;
        sequence.push(newS);
        sequence.push(toExecuteS.innerHTML);
      } else {
        sequence.push(toExecuteS.innerHTML);
      }
    }

    // filter out scripts already loaded on page
    console.log('CMP.parseScriptsInHtml - filtering out scripts already loaded on page');
    console.log('CMP.parseScriptsInHtml - sequence', JSON.stringify(sequence));
    const filteredSequence = sequence.filter(
      script => document.querySelectorAll(`script[src="${script.src}"]`).length === 0
    );
    console.log('CMP.parseScriptsInHtml - filteredSequence', JSON.stringify(filteredSequence));

    // iterate through scripts and eval() or add to page
    this.evalScripts(filteredSequence);
  };

  render() {
    const {
      componentName,
      style,
      parentRef,
      creative: { type, interstitial_html },
    } = this.props;

    return (
      <div className="e2-celtra-styling">
        {this.state.newHtml && (
          // eslint-disable-next-line react/no-danger
          <div
            ref={parentRef}
            id={componentName}
            title={componentName}
            className="e2-ad-html"
            style={this.getE2AdHtmlStyle(this.state.newHtml, style)}
            dangerouslySetInnerHTML={{ __html: this.state.newHtml }}
          />
        )}
      </div>
    );
  }
}

export default CMP;
